
<div id="kt_header_mobile"
    class="header-mobile align-items-center {{currentTheme.baseSettings.header.mobileFixedHeader ? 'header-mobile-fixed':''}}">
    <a routerLink="/" target="_blank" class="ml-15">
        <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" [src]="'/assets/common/images/ITPUpdatedIcon2.svg'"
            alt="logo" height="28" />
        <img *ngIf="appSession.tenant && appSession.tenant.logoId"
            [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId"
            alt="logo" height="38" />
    </a>
    <div class="d-flex align-items-center">
        <button class="btn p-0 burger-icon burger-icon-left" id="kt_aside_mobile_toggle" style="color:#0095da">
            <!--<span></span>-->
            <span class="svg-icon svg-icon svg-icon-xl"><svg xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24"
                    version="1.1">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <polygon points="0 0 24 0 24 24 0 24"></polygon>
                        <path
                            d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                            fill="#000000" fill-rule="nonzero"
                            transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) ">
                        </path>
                        <path
                            d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                            fill="#000000" fill-rule="nonzero" opacity="0.3"
                            transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) ">
                        </path>
                    </g>
                </svg></span>
        </button>
        <button ktToggle [options]="userMenuToggleOptions" class="btn btn-hover-text-primary p-0 ml-2"
            id="kt_header_mobile_topbar_toggle">
            <span class="svg-icon svg-icon-xl">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                    <path
                        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                </svg>
            </span>
        </button>
    </div>
</div>

<div [@routerTransition] class="d-flex flex-column flex-root">
    <div class="d-flex flex-row flex-column-fluid mt-md-1 mt-lg-12 mt-xl-15 page">
        <div id="kt_aside" ktOffcanvas [options]="menuCanvasOptions"
            class="aside aside-left aside-{{currentTheme.baseSettings.menu.fixedAside ? 'fixed':'static'}} d-flex flex-column flex-row-auto">
            <default-brand></default-brand>
            <div id="kt_aside_menu_wrapper" class="aside-menu-wrapper flex-column-fluid">
                <side-bar-menu></side-bar-menu>
            </div>
            <!-- <div class="pl-7" style="color: gray;"> {{webAppVersion}}</div> -->
        </div>
        <button class="brand-toggle btn btn-sm px-0 border-0 custom-style-logo-icon position-fixed" id="kt_aside_toggle" id="kt_aside_toggler"
            *ngIf="currentTheme.baseSettings.menu.allowAsideMinimizing" [ngStyle]="{'left': !defaultBrand?.isCollapsed ? '19rem' : '4rem'}" (click)="defaultBrand?.toggleLeftAside()">
            <span class="svg-icon svg-icon svg-icon-xl">
                <img *ngIf="defaultBrand?.isCollapsed" src="/assets/common/images/Expand.svg" alt="logo" height="24"  />
                <img *ngIf="!defaultBrand?.isCollapsed" src="/assets/common/images/Collapse.svg" alt="logo" height="24"  />

            </span>
        </button>
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
            <div id="kt_header"
                class="header header-{{currentTheme.baseSettings.header.desktopFixedHeader  ? 'fixed':'fixed'}} head--skin-{{currentTheme.baseSettings.header.headerSkin}}">
                <div class="{{containerClass}} d-flex align-items-stretch justify-content-end topbarAlign px-2">
                    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
                    </div>
                    <div class="topbar w-100" id="dropdown-hover-color-default">

                        <!-- ====================================================================================================== -->

                        <div class=" mr-auto d-flex align-items-center font-size-sm breadcrumb-container">
                            <ul *ngIf="breadcrumbs && breadcrumbs.length > 0 "
                                class='breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bolder p-0 my-2 fs-6 pt-6 pt-lg-0'>
                                <li class='breadcrumb-item' *ngFor="let breadcrumbItem of breadcrumbs">
                                    <a *ngIf="breadcrumbItem.isLink()"
                                       (click)="goToBreadcrumb(breadcrumbItem)" class=' font-size-14'>
                                        {{ breadcrumbItem.text | localize}}
                                    </a>
                                    <span *ngIf="!breadcrumbItem.isLink()" class='bold cursor-pointer' (click)="onClick(breadcrumbItem.text)">{{breadcrumbItem.text | localize}}</span>



                                    <div *ngIf="breadcrumbItem?.text =='Clients  |'">

                                        <div *ngIf="isGranted('Pages.Clients.CRUD'); else notGrantedClients" class="dropdown" dropdown (isOpenChange)="uparrow=!uparrow" id="caret">
                                            <a dropdownToggle class=" p-0 font-weight-bolder ml-2"
                                               style="color: #0095DA;">
                                                {{_defaultLayoutService.clientSelectedHeading |localize}}
                                                <i class="la ml-2 font-weight-bold"
                                                   [ngClass]=" uparrow ? 'la-angle-down' : 'la-angle-up'"
                                                   style="color: #0095DA;"></i>
                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu >
                                                <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body" (click)="selectedTabForClient(1)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ActiveClients" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                                <li *ngIf="isGranted('Pages.Clients.CRUD')" class="navi navi-hover mt-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body" (click)="selectedTabForClient(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ArchivedClients" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                                <li *ngIf="isGranted('Pages.Clients.CRUD')" class="navi navi-hover mb-2 mt-2 h-25px ">
                                                    <a class="navi-item  intime-open-sans cursor-pointer text-body" (click)="selectedTabForClient(3)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"DeletedClients" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                            </ul>
                                        </div>
                                        <ng-template #notGrantedClients>
                                            <span class="ml-2">{{'ActiveClients' |localize}}</span>
                                        </ng-template>
                                    </div>

                                    <div *ngIf="breadcrumbItem?.text =='Projects  |'">

                                        <div *ngIf="isGranted('Pages.Projects.CRUD'); else notGrantedProject" class="dropdown" dropdown (isOpenChange)="uparrow=!uparrow" id="caret">
                                            <a dropdownToggle class=" p-0 font-weight-bolder ml-2">
                                                {{_defaultLayoutService.projectSelectedHeading | localize}}
                                                <i class="la ml-2 font-weight-bold"
                                                   [ngClass]=" uparrow ? 'la-angle-down' : 'la-angle-up'"
                                                  ></i>
                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu style="margin-top: 1px;">
                                                <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="selectedTabForProject(1)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ActiveProjects" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.Projects.CRUD')" class="navi navi-hover mt-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="selectedTabForProject(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ArchivedProjects" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                                <li *ngIf="isGranted('Pages.Projects.CRUD')" class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="selectedTabForProject(3)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"DeletedProjects" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                            </ul>
                                        </div>
                                        <ng-template #notGrantedProject>
                                            <span class="ml-2">{{'ActiveProjects' |localize}}</span>
                                        </ng-template>
                                    </div>

                                    <div class="d-flex ml-2" *ngIf="breadcrumbItem.text == 'Products and Services' && productServiceSelectionTypeValue =='Products'">
                                        | <div *ngIf="isGranted('Pages.ProductService.CRUD'); else notGrantedProducts" class="dropdown" dropdown (isOpenChange)="onOpenChange($event)" id="caret" disabled="true">
                                            <a dropdownToggle class="p-0 font-weight-bolder ml-2" style="color: #0095DA; ">
                                                {{productSelectionDropdownValue | localize}}
                                                <i class="la ml-2 font-weight-bold {{textForClass}} "
                                                   style="color: #0095DA; "></i>

                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-right" id="tab1" *dropdownMenu>
                                                <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="productSelectionType(1)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ActiveProducts" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="productSelectionType(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ArchivedProducts" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="productSelectionType(3)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"DeletedProducts" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                            </ul>
                                        </div>
                                        <ng-template #notGrantedProducts>
                                            <span class="ml-2">{{'ActiveProducts' |localize}}</span>
                                        </ng-template>
                                    </div>

                                    <div class="d-flex ml-2" *ngIf="breadcrumbItem.text == 'Products and Services' && productServiceSelectionTypeValue =='Services'">
                                        | <div *ngIf="isGranted('Pages.ProductService.CRUD'); else notGrantedServices" class="dropdown" dropdown (isOpenChange)="onOpenChange($event)" id="caret">
                                            <a dropdownToggle class="p-0 font-weight-bolder ml-2" style="color: #0095DA; ">
                                                {{serviceSelectionDropdownValue | localize}}
                                                <i class="la ml-2 font-weight-bold {{textForClass}} "
                                                   style="color: #0095DA; "></i>

                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-end " id="tab1" *dropdownMenu>
                                                <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="serviceSelectionType(1)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ActiveServices" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="serviceSelectionType(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"ArchivedServices" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                                <li *ngIf="isGranted('Pages.ProductService.CRUD')" class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body"(click)="serviceSelectionType(2)">
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"DeletedServices" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                            </ul>
                                        </div>
                                        <ng-template #notGrantedServices>
                                            <span class="ml-2">{{'ActiveServices' |localize}}</span>
                                        </ng-template>
                                    </div>

                                    <!-- <div *ngIf="breadcrumbItem.text == 'Manage Users' && !isuserDetailsPage">
                                        <div class="d-flex ml-2">
                                           |
                                            <div *ngIf="isGranted('Pages.Administration.User.CRUD'); else notGrantedUsers" class="dropdown" dropdown (isOpenChange)="uparrow=!uparrow" id="caret">
                                                <a dropdownToggle class=" p-0 font-weight-bolder ml-2"
                                                   style="color: #0095DA; ">
                                                    {{_defaultLayoutService.userSelectedType | localize}}
                                                    <i class="la ml-2 font-weight-bold"
                                                       [ngClass]=" uparrow ? 'la-angle-down' : 'la-angle-up'"
                                                       style="color: #0095DA; "></i>
                                                </a>
                                                <ul class="dropdown-menu" *dropdownMenu style="margin-top: 1px;">
                                                    <li>
                                                        <a class="cursor-pointer intime-open-sans px-5 py-1 text-body bottom-border-none"
                                                           (click)="selectedUserTab(1)">
                                                            {{'activeUsers' | localize}}
                                                        </a>
                                                    </li>
                                                    <li *ngIf="isGranted('Pages.Administration.User.CRUD')">
                                                        <a class="cursor-pointer intime-open-sans px-5 py-1 text-body bottom-border-none"
                                                           (click)="selectedUserTab(2)">
                                                            {{'ArchivedUsers' | localize}}
                                                        </a>
                                                    </li>
                                                    <li *ngIf="isGranted('Pages.Administration.User.CRUD')">
                                                        <a class="cursor-pointer intime-open-sans px-5 py-1 text-body bottom-border-none"
                                                           (click)="selectedUserTab(3)">
                                                            {{'DeletedUsers' | localize}}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <ng-template #notGrantedUsers>
                                                <span class="ml-2">{{'activeUsers' |localize}}</span>
                                            </ng-template>

                                    </div></div> -->

                                    <div class="d-flex ml-2" *ngIf="breadcrumbItem.text == 'Dashboard' &&  !this.isCheckProfile">
                                        |
                                        <div class="dropdown" dropdown (isOpenChange)="uparrow=!uparrow" id="caret">
                                            <a dropdownToggle class=" p-0 font-weight-bolder ml-2"
                                               style="color: #0095DA; ">
                                                {{dashboardSelectedType | localize}}
                                                <i class="la ml-2 font-weight-bold"
                                                   [ngClass]=" uparrow ? 'la-angle-down' : 'la-angle-up'"
                                                   style="color: #0095DA; "></i>
                                            </a>
                                            <ul class="dropdown-menu dropdown-menu-right w-150px" *dropdownMenu >

                                                 <li class="navi navi-hover h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body" (click)="selectedTabDashboard(0)" >
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"MyDashboard" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>
                                                <li class="navi navi-hover mt-2 mb-2 h-25px ">
                                                    <a class="navi-item intime-open-sans cursor-pointer text-body" (click)="selectedTabDashboard(1)" >
                                                       <div class="navi-link">
                                                            <div class="navi-text">
                                                               <div class="font-weight-bold">
                                                                   {{"TeamDashboard" | localize}}
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </a>
                                                 </li>

                                            </ul>
                                        </div>


                                    </div>



                                    <div *ngIf="breadcrumbItem?.text == 'Dashboard  |' &&  isCheckProfile" id="check-color">
                                        <span class=" ml-3 font-weight-bolder intime-open-sans mt-1 bg-font-color">My Dashboard</span>

                                    </div>


                                </li>
                            </ul>

                        </div>

                        <!-- ====================================================================================================================== -->
                        <div class="bg-white d-flex topbar-menus">
                            <div class="topbar-item subscription-warning d-print-none "
                                 *ngIf="!isMobileDevice() && subscriptionStatusBarVisible()">
                                <subscription-notification-bar></subscription-notification-bar>
                            </div>

                            <active-delegated-users-combo *ngIf="!installationMode"></active-delegated-users-combo>
                            <quick-theme-selection></quick-theme-selection>
                            <!--<language-switch-dropdown></language-switch-dropdown>-->

                            <div *ngIf="!this.isClient" [ngClass]="{'isSidebarChecklandingPageTopbar': !isLoginForFirstTime}">
                                <app-setting-topbar (click)="companyProfileClick()"></app-setting-topbar>

                            </div>
                            <help-menu></help-menu>
                            <div *ngIf="!this.isClient"
                                 [ngClass]="{'isSidebarChecklandingPageTopbar': !isLoginForFirstTime}">
                                <app-downloadfile></app-downloadfile>
                            </div>

                            <header-notifications></header-notifications>

                             <div *ngIf="isProfileData" class="d-flex align-items-center">
                            <user-menu></user-menu>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="p-3 mobile-subscription-warning d-print-none"
                *ngIf="isMobileDevice() && subscriptionStatusBarVisible()">
                <subscription-notification-bar></subscription-notification-bar>
            </div>

                <div class="flex-grow-1 overflow-hidden m-3 mt-11 mt-md-3">
                    <router-outlet></router-outlet>
                </div>


        </div>
    </div>
</div>
